'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('moment-range');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var value = _ref.value,
      classes = _ref.classes;
  return _react2.default.createElement(
    'div',
    { className: classes + ' cell' },
    value
  );
};


//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/dist/cell.js
// module id = 324
// module chunks = 3